"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
class UomChargeMethodValidator extends GenericValidator_1.default {
    _schema = joi_1.default.object({
        primaryUnitsChargeAmount: joi_1.default.number().precision(4).optional(),
        secondaryUnitsChargeAmount: joi_1.default.number().precision(4).optional(),
        packagingUnitsChargeAmount: joi_1.default.number().precision(4).optional(),
        movableUnitsChargeAmount: joi_1.default.number().precision(4).optional(),
    });
    validate(uomChargeMethod) {
        const schemaErrors = this._schema.validate(uomChargeMethod, {
            abortEarly: false,
            convert: false,
        });
        const uomChargeMethodIssues = super.handleIssues(schemaErrors, 'IUomChargeMethod');
        if (uomChargeMethodIssues.length > 0) {
            return uomChargeMethodIssues;
        }
    }
}
exports.default = UomChargeMethodValidator;
